export const CLEAR_SEARCH_DATA = 'CLEAR_SEARCH_DATA';